import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getData } from "../api/ApiRest";

////Me optimiza el llamado de funciones manualmente como: pending, fulfilled, reject, por medio de funcionas asincronizas (API),
////para la modificación del store 
export const fetchRoles = createAsyncThunk(
    "auth/fetchRoles",
    async (_, { rejectWithValue }) => { ///Cuando no se requiere un parametro por defecto se deja _, y el otro parametro es para retornar un error personalizado
        try {
            const res = await getData('api/Usuario/refrescaRoles').then(response => {
                return response;
            }, error => console.log(error)); ///Realizamos llamado al api de manera asincrona

            return res.roles_Results; ///Cuando la respuesta es correcta procede a alimentar el fulfilled
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
)

const initialState = {
    user: null, ///Datos del usuario
    roles: [], ///Roles asignado al usuario
    token: null, ///Token de seguridad
    isAuthenticated: false, //Flag para sabar si ya inicio sesión o cerro
    loadingRoles: false,
    errorRoles: null,
    isAdmin: false,
    company: null,
    tokenSesion: null,
    tokenSesionInicio: null,
    tokenSesionFin: null,
    AmbienteApiDian_Url: null,
    AmbienteTae_Url: null,
    AdminTae: null,
    CompanyId: null,
    novedades: [] ///Novedades de actualizaciones por compañia
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginSuccess: (state, action) => {
            const { user, token, roles, isAdmin, company, tokenSesion, tokenSesionFin,
                tokenSesionInicio, AmbienteApiDian_Url, AmbienteTae_Url, AdminTae, CompanyId, novedades } = action.payload;

            state.user = user;
            state.token = token;
            state.roles = roles;
            state.isAdmin = isAdmin;
            state.company = company;
            state.tokenSesion = tokenSesion;
            state.tokenSesionFin = tokenSesionFin;
            state.tokenSesionInicio = tokenSesionInicio;
            state.AmbienteApiDian_Url = AmbienteApiDian_Url;
            state.AmbienteTae_Url = AmbienteTae_Url;
            state.AdminTae = AdminTae;
            state.CompanyId = CompanyId;
            state.novedades = novedades;
        },
        logout: (state) => {
            state.user = null;
            state.roles = [];
            state.token = null;
            state.isAuthenticated = false;
            state.isAdmin = false;
            state.company = null;
            state.tokenSesion = null;
            state.tokenSesionFin = null;
            state.tokenSesionInicio = null;
            state.AmbienteApiDian_Url = null;
            state.AmbienteTae_Url = null;
            state.AdminTae = null;
            state.CompanyId = null;
            state.novedades = [];
        },
        removeNovedades: (state) => {
            state.novedades = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchRoles.pending, (state) => {
                state.loadingRoles = true;
                state.errorRoles = null;
            })
            .addCase(fetchRoles.fulfilled, (state, action) => {
                state.loadingRoles = false;
                state.roles = action.payload;
            })
            .addCase(fetchRoles.rejected, (state, action) => {
                state.loadingRoles = false;
                state.errorRoles = action.payload;
            })
    }
});

export const { loginSuccess, logout, removeNovedades } = authSlice.actions;
export default authSlice.reducer;